<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header no" style="padding-top: 0px !important;">
                <!-- <h4 style="float: left;">All Attendances : </h4> -->
                <!-- <div style="clear: both;margin-bottom: 5px;"></div> -->
                <div style="text-align: center;">
                    <h2 class="p-2" style="text-align:center;background-color: red;display:inline-block;color: white;">From<input (change)='totalmoney()' type="date" [(ngModel)]='dateAttend'></h2>
                    <h2 class="p-2" style="text-align:center;background-color: red;display:inline-block;color: white;">To<input (change)='totalmoney()' type="date" [(ngModel)]='dateAttend01New'></h2>
                    <h2 class="p-2 ml-1" style="text-align:center;display:inline-block;color: black;font-weight: bolder;">Total : {{totalMoney}}</h2>
                    <!-- <button *ngIf='add' (click)='addUser()' type="button" class="btn btn-dark ml-2" style="box-shadow: none; background-color: black !important;line-height:0; display: inline;height: 43px;"><i style='font-size:27px;' class="fas fa-plus-square"></i></button> -->
                </div>
                <div id='fdgh' class='col-12 choose3' style='background-color: #292929;'>
                    <form id='upd-up00' #datadf4='ngForm' (submit)='addUser0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
              <div class='container-fluid pl-1 pr-1'>
                <div class='row'>
                  <div class='col-md-3'></div>
                  <div class='col-md-3'>
                    <label style="color: white;">Date</label>
                    <input (change)='goFilter()' style='width: 94.5% !important;height: 27px;display: inline-block;' class="text mb-2 d1" type="date" name="date" [(ngModel)]='date' placeholder="Add Money" required="" id="theDate">
                  </div>
                  <div class='col-md-3'>
                    <label style="color: white;">Account</label>
                    <select name="root" class="form-control mt-4 select2 rootSelect000" style="height: unset !important;">
                      <option value='undefined' disabled selected>Account</option>
                      <option *ngFor='let x of arrRoot|account:idLevel2' [value]="x.id">{{x.name}}</option>
              </select>
                  </div>
                  <div class='col-md-3'></div>
                  <div class='col-md-2'>
                    <label style="color: white;">Money</label>
                    <input style='width: 94.5% !important;height: 27px;display: inline-block;' class="text mb-2 d1 UpCha" type="number" name="The_Amount" [(ngModel)]='The_Amount' placeholder="Money" required="">
                  </div>
                  <div class='col-md-3 lastU'>
                    <label style="color: white;">Account_Name</label>
                    <select class="form-control mt-4 select2 Account_Name" style="height: unset !important;">
                      <option disabled selected value='undefined'>Account_Name</option>
                        <ng-container *ngFor='let r of arrRoot|accountFilter:null'>
                          <option [value]="r.id">* {{r.name}}</option>
                        <ng-container *ngFor='let x of arrRoot|account:r.id'>
                          <option [value]="x.id">&nbsp;&nbsp;&nbsp;** {{x.name}}</option>
                          <ng-container *ngFor='let y of arrRoot|account:x.id'>
                            <option [value]="y.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*** {{y.name}}</option>
                            <ng-container *ngFor='let f of arrRoot|account:y.id'>
                              <option [value]="f.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;**** {{f.name}}</option>
                              <ng-container *ngFor='let cc of arrRoot|account:f.id'>
                                <option [value]="cc.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;***** {{cc.name}}</option>
                                <ng-container *ngFor='let cg of arrRoot|account:cc.id'>
                                  <option [value]="cg.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;****** {{cg.name}}</option>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                                      </ng-container>
                                      </ng-container>
                                      </select>
                  </div>
                  <div class='col-md-3 lastU'>
                    <label style="color: white;">Sub_Account</label>
                      <select class="form-control mt-4 select2 Sub_Account" style="height: unset !important;">
      <option disabled selected value="undefined">Sub_Account</option>
      <option *ngFor='let r of arrRootSub|searchSubAccount:Account_Name_search' [value]="r.id">{{r.name}}</option>
      </select>
                  </div>
                  <div class='col-md-2'>
                    <label style="color: white;">Notes</label>
                      <input style='width: 94.5% !important;height: 27px;display: inline-block;' class="text mb-2 d1 UpCha" type="text" name="Notes" [(ngModel)]='Notes' placeholder="Notes" required="">
                  </div>
                  <div class='col-md-1'>
                    <label style="color: white;">Type</label>
                    <select name="type" [(ngModel)]='type' class="form-control mb-2" style="height: 28px !important;">
                      <option disabled selected>Type</option>
                      <option>Debit مدين</option>
                      <option>Creditor دائن</option>
                    </select>
                  </div>
                 <!--  <div class='col-md-1'>
                    <label style="color: white;">Payment_Way</label>
  <select [(ngModel)]='PaymentWay' name="PaymentWay" class="form-control mb-2 sO" style="height: 28px !important;padding: 0  !important;">
    <option value='undefined' disabled selected>Payment Way</option>
    <option value='Cash' style="color: black !important;">Cash</option>
    <option value='Visa' style="color: black !important;">Visa</option>
    <option value='Check' style="color: black !important;">Check</option>
    </select>
                  </div> -->
                  <!-- <div class='col-sm-2'>
                    <input style='height: 54px;' class="text mt-2 d1" type="number" name="pay" [(ngModel)]='pay' placeholder="payment" required="">
                  </div>-->
                  <!-- <div class="col-sm-2">
                    <label style='color: white;'>Discound : &nbsp;&nbsp;</label>
                    <input style='width: 73% !important;height: 49px;display: inline-block;' class="text mt-2 d1 submitNumber" type="number" name="discound" [(ngModel)]='discound' placeholder="Discound" required="">
                  </div> -->
                  <div class="col-md-1 mt-4">
                    <button style='margin-top: auto; width:100%;line-height:1;padding: 4px !important;' class='btn btn-secondary' type="submit"><i class="fas fa-plus"></i></button>
                    <!-- <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;" type="submit" value="Add"> -->
                  </div>
                  </div>
              </div>
      <div style="clear: both;"></div>
      </span>
                    </form>
                </div>
                <!-- <div class="container-fluid">
          <div class="row">
              <div class="col-lg-3 col-12">
                  <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
              </div>
              <div class="col-lg-3 col-12"> -->
                <!-- <label>From : </label><br> -->
                <!-- <input *ngIf='OrderDate000S0' (change)='goDate()' id="fromDG" placeholder="Search By Code" class="p-1 mb-2 fromDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                  <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000S' (mouseenter)='OrderDate0010S()' class="text d1 mb-2" type="text" placeholder="From Date" required="">
              </div>
              <div class="col-lg-3 col-12"> -->
                <!-- <label>To : </label><br> -->
                <!-- <input *ngIf='OrderDate000SS0' (change)='goDate()' id="toDG" placeholder="Search By Code" class="p-1 mb-2 toDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                  <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000SS' (mouseenter)='OrderDate0010SS()' class="text d1 mb-2" type="text" placeholder="To Date" required="">
              </div> -->
                <!-- <div class="col-lg-3 col-12">
                  <select [(ngModel)]='rootSearch' class="form-control mb-2" style="height: 32px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                <option disabled>Search By Root</option>
                <option>All</option>
                <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
        </select>
              </div> -->
                <!-- <div class="col-lg-3 col-12">
                  <select [(ngModel)]='controlSearch' class="form-control mb-2" style="height: 32px !important;width: 100%;border: 1px solid black !important; color: black !important;line-height: 0;">
                <option disabled>Search By Permission</option>
                <option>All</option>
                <option *ngFor='let r of controlA' [value]="r.id">{{r.name}}</option>
              </select>
              </div> -->
                <!-- <div class="col-lg-2 col-12">
                  <button (click)='addUser()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height: 0; " type="button" class="btn btn-secondary mb-2">Add Attendance</button>
              </div>
              <div class='col-lg-1 col-12'>
                  <button (click)='printert()' class="btn btn-secondary" style="height: 32px !important;border: 1px solid black !important;width: 94.5% !important;line-height: 0;"><i class="fas fa-print"></i></button>
              </div>
          </div>
      </div> -->
            </div>





            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 54vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table id='calltable' class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">No.</th>
                                    <th scope="col">Account_Name</th>
                                    <th scope="col">Sub_Account</th>
                                    <th scope="col">Money</th>
                                    <th scope="col">Notes</th>
                                    <!-- <th scope="col">Account</th>

                                <th scope="col">Type</th>


                                <th scope="col">Employee_Name</th> -->
                                    <!-- <th scope="col">Payment_Way</th> -->

                                    <th scope="col">Due Date</th>
                                    <th scope="col" style='z-index: 1;'>Update</th>
                                    <th scope="col" style='z-index: 1;'>Delete</th>
                                    <!-- <th scope="col">Update</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of rootA|typeAccount:"All"|samedate:dateAttend:dateAttend01New; let n = index;'>
                                    <th scope="row" style="text-align: center;">{{n+1}}</th>
                                    <td data-title="Account_Name" class="selectintable">{{v.Account_Name_name}}</td>
                                    <td data-title="Sub_Account" class="selectintable">{{v.Sub_Account_name}} {{v.nameCustomer}}</td>
                                    <td data-title="Money">{{v.money}}</td>
                                    <td data-title="Notes">{{v.notes}}</td>
                                    <!-- <td data-title="Treasury">{{v.treasury_Name_name}}</td>

                                <td data-title="Type">{{v.type}}</td>


                                <td data-title="Employee_Name">{{v.username}}</td> -->
                                    <!-- <td data-title="Payment_Way">{{v.waypay}}</td> -->

                                    <td data-title="Due Date">{{v.date| date:'dd-MM-yyyy'}}</td>
                                    <td data-title="Update"><button (click)='upP(v)' class='btn btn-success' style='box-shadow: none !important;'><i class="fas fa-sync-alt rotating"></i></button></td>
                                    <td data-title="Delete"><button (click)='delU(v.id)' class='btn btn-danger' style='box-shadow: none !important;'><i class="fas fa-trash-alt"></i></button></td>
                                    <!-- <td data-title="Absence_with_permission"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios4{{v.id}}" value="Absence_with_permission"></td>
                          <td data-title="Absence"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios5{{v.id}}" value="Absence"></td>
                          <td data-title="Absence_of_vacation_balance"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios6{{v.id}}" value="Absence_of_vacation_balance"></td> -->
                                    <!-- <td data-title="Update"><button (click)='upP(v)' class='btn btn-success' style='box-shadow: none !important;'><i class="fas fa-sync-alt rotating"></i></button></td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>















        </div>
    </div>
    <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addUser0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
                    <label style="color: white;">Date : </label>
                    <input style='height: 25px;' class="text mt-2 d1" type="date" name="date" [(ngModel)]='date' placeholder="Add Money" required="" id="theDate">
                    <label style="color: white;">Money : </label>
                    <input style="height: 25px;" class="text mt-2 d1 UpCha" type="number" name="The_Amount" [(ngModel)]='The_Amount' placeholder="Money" required="">
                    <label style="color: white;" class="mt-2">Account_Name : </label>
                    <select class="form-control mt-4 select2 Account_Name" style="height: unset !important;">
                      <option disabled selected value='undefined'>Account_Name</option>
                        <ng-container *ngFor='let r of arrRoot|accountFilter:null'>
                          <option [value]="r.id">* {{r.name}}</option>
                        <ng-container *ngFor='let x of arrRoot|account:r.id'>
                          <option [value]="x.id">&nbsp;&nbsp;&nbsp;** {{x.name}}</option>
                          <ng-container *ngFor='let y of arrRoot|account:x.id'>
                            <option [value]="y.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*** {{y.name}}</option>
                            <ng-container *ngFor='let f of arrRoot|account:y.id'>
                              <option [value]="f.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;**** {{f.name}}</option>
                              <ng-container *ngFor='let cc of arrRoot|account:f.id'>
                                <option [value]="cc.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;***** {{cc.name}}</option>
                                <ng-container *ngFor='let cg of arrRoot|account:cc.id'>
                                  <option [value]="cg.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;****** {{cg.name}}</option>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                                      </ng-container>
                                      </ng-container>
                                      </select>
                      <label style="color: white;" class="mt-2">Sub_Account : </label>
                      <select class="form-control mt-4 select2 Sub_Account" style="height: unset !important;">
      <option disabled selected value="undefined">Sub_Account</option>
      <option *ngFor='let r of arrRootSub|searchSubAccount:Account_Name_search' [value]="r.id">{{r.name}}</option>
      </select>
                      <label style="color: white;" class="mt-2">Notes : </label>
                      <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="Notes" [(ngModel)]='Notes' placeholder="Notes" required="">
                      <label style="color: white;" class="mt-2">Type : </label>
                    <select name="type" [(ngModel)]='type' class="form-control mt-2" style="height: unset !important;">
                      <option disabled selected>Type</option>
                      <option>Debit مدين</option>
                      <option>Creditor دائن</option>
                    </select>
                    <label style="color: white;" class="mt-2">Payment Way : </label>
  <select [(ngModel)]='PaymentWay' name="PaymentWay" class="form-control mt-2 sO" style="height: 25px !important;padding: 0  !important;">
    <option value='undefined' disabled selected>Payment Way</option>
    <option value='Cash' style="color: black !important;">Cash</option>
    <option value='Visa' style="color: black !important;">Visa</option>
    <option value='Check' style="color: black !important;">Check</option>
    </select>
                      <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Add">
                      <div style="clear: both;"></div>
      </span>
                    </form>
                </div>
            </div>
        </div>
    </section>

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
  <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Are You Sure ?">
  <div style="clear: both;"></div>
  </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data='ngForm' (submit)='okUp(data.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                <label style="color: white;">Date : </label>
                    <input style='height: 25px;' class="text mt-2 d1" type="date" name="dateUpdate" [(ngModel)]='dateUpdate' required="">
            <label style="color: white;">Money : </label>
          <input style="height: 25px;" class="text mt-2 d1 UpCha" type="number" name="The_AmountUpdate" [(ngModel)]='The_AmountUpdate' placeholder="Money" required="">
          <label style="color: white;" class="mt-2">Account_Name : </label>
<select class="form-control mt-4 select2 Account_NameUpdate" style="height: unset !important;">
<option disabled selected>Account_Name</option>
<ng-container *ngFor='let r of arrRoot|accountFilter:null'>
<option [value]="r.id">* {{r.name}}</option>
<ng-container *ngFor='let x of arrRoot|account:r.id'>
<option [value]="x.id">&nbsp;&nbsp;&nbsp;** {{x.name}}</option>
<ng-container *ngFor='let y of arrRoot|account:x.id'>
  <option [value]="y.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*** {{y.name}}</option>
  <ng-container *ngFor='let f of arrRoot|account:y.id'>
    <option [value]="f.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;**** {{f.name}}</option>
    <ng-container *ngFor='let cc of arrRoot|account:f.id'>
      <option [value]="cc.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;***** {{cc.name}}</option>
      <ng-container *ngFor='let cg of arrRoot|account:cc.id'>
        <option [value]="cg.id">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;****** {{cg.name}}</option>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
            </ng-container>
            </ng-container>
            </select>
            <label style="color: white;" class="mt-2">Sub_Account : </label>
            <select class="form-control mt-4 select2 Sub_AccountUpdate" style="height: unset !important;">
<option disabled selected>Sub_Account</option>
<option *ngFor='let r of arrRootSub|searchSubAccount:Account_Name_searchUpdate' [value]="r.id">{{r.name}}</option>
</select>
            <label style="color: white;" class="mt-2">Notes : </label>
            <input style="height: 25px;" class="text mt-2 d1 UpCha" type="text" name="NotesUpdate" [(ngModel)]='NotesUpdate' placeholder="Notes" required="">
          <label style="color: white;" class="mt-2">Type : </label>
          <select name="type" [(ngModel)]='type' class="form-control mt-2" style="height: unset !important;">
            <option disabled selected>Type</option>
            <option>Debit مدين</option>
            <option>Creditor دائن</option>
          </select>
          <!-- <label style="color: white;" class="mt-2">Payment Way : </label>
  <select [(ngModel)]='PaymentWayUpdate' name="PaymentWayUpdate" class="form-control mt-2 sO" style="height: 25px !important;padding: 0  !important;">
    <option value='undefined' disabled selected>Payment Way</option>
    <option value='Cash' style="color: black !important;">Cash</option>
    <option value='Visa' style="color: black !important;">Visa</option>
    <option value='Check' style="color: black !important;">Check</option>
    </select> -->
            <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Update">
            <div style="clear: both;"></div>
            </span>
                </form>
            </div>
        </div>
    </div>
</section>